var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSubjectsBlue = function SvgIconSubjectsBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-subjects",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M151.284 136.8v11h-2v13h18a4 4 0 0 0 4-4v-20Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    "data-name": "Rectangle 25",
    d: "M0 0h4v11a2 2 0 0 1-2 2 2 2 0 0 1-2-2V0Z",
    transform: "translate(0 11)",
    fill: "#1eaae1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M156.284 141.8h10a1 1 0 0 1 0 2h-10a1 1 0 0 1 0-2Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#2980b9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M156.284 145.8h10a1 1 0 0 1 0 2h-10a1 1 0 0 1 0-2Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#2980b9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M156.284 149.8h10a1 1 0 0 1 0 2h-10a1 1 0 0 1 0-2Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#2980b9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M155.95 153.8h6.667c.367 0 .667.45.667 1s-.3 1-.667 1h-6.667c-.366 0-.666-.45-.666-1s.3-1 .666-1Z",
    transform: "translate(-147.284 -136.799)",
    fill: "#2980b9"
  })));
};
export { SvgIconSubjectsBlue as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zdWJqZWN0cyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8cGF0aCBpZD0iUGF0aF8xMTEiIGRhdGEtbmFtZT0iUGF0aCAxMTEiIGQ9Ik0xNTEuMjg0LDEzNi44djExaC0ydjEzaDE4YTQsNCwwLDAsMCw0LTR2LTIwWiIKICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNDcuMjg0IC0xMzYuNzk5KSIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggaWQ9IlJlY3RhbmdsZV8yNSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMjUiCiAgICAgICAgICBkPSJNMCwwSDRBMCwwLDAsMCwxLDQsMFYxMWEyLDIsMCwwLDEtMiwySDJhMiwyLDAsMCwxLTItMlYwQTAsMCwwLDAsMSwwLDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDExKSIKICAgICAgICAgIGZpbGw9IiMxZWFhZTEiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzExMiIgZGF0YS1uYW1lPSJQYXRoIDExMiIgZD0iTTE1Ni4yODQsMTQxLjhoMTBhMSwxLDAsMCwxLDAsMmgtMTBhMSwxLDAsMCwxLDAtMloiCiAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQ3LjI4NCAtMTM2Ljc5OSkiIGZpbGw9IiMyOTgwYjkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzExMyIgZGF0YS1uYW1lPSJQYXRoIDExMyIgZD0iTTE1Ni4yODQsMTQ1LjhoMTBhMSwxLDAsMCwxLDAsMmgtMTBhMSwxLDAsMCwxLDAtMloiCiAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQ3LjI4NCAtMTM2Ljc5OSkiIGZpbGw9IiMyOTgwYjkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzExNCIgZGF0YS1uYW1lPSJQYXRoIDExNCIgZD0iTTE1Ni4yODQsMTQ5LjhoMTBhMSwxLDAsMCwxLDAsMmgtMTBhMSwxLDAsMCwxLDAtMloiCiAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQ3LjI4NCAtMTM2Ljc5OSkiIGZpbGw9IiMyOTgwYjkiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzExNSIgZGF0YS1uYW1lPSJQYXRoIDExNSIKICAgICAgICAgIGQ9Ik0xNTUuOTUsMTUzLjhoNi42NjdjLjM2NywwLC42NjcuNDUuNjY3LDFzLS4zLDEtLjY2NywxSDE1NS45NWMtLjM2NiwwLS42NjYtLjQ1LS42NjYtMVMxNTUuNTg0LDE1My44LDE1NS45NSwxNTMuOFoiCiAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTQ3LjI4NCAtMTM2Ljc5OSkiIGZpbGw9IiMyOTgwYjkiLz4KPC9zdmc+Cg==";